import type {CustomDealProduct} from '../../../../../types';

import promotionIcon from 'assets/images/promotion-center/promotion-icon-primary-color.svg';
import ProductBadge from '../../../../../components/common/ProductBadge/ProductBadge';
import StockBadge from '../../../../../components/common/StockBadge/StockBadge';
import {numberFormat} from 'utils/Helper';

type DealDetailProductsListItemProps = {
  item: CustomDealProduct;
};

const DealDetailProductsListItem: React.FC<DealDetailProductsListItemProps> = ({item}) => {
  const stock = item.stock || 0;
  const discount = item.discount || 0;
  const hasDiscount = discount > 0;
  const originalPrice = +item.price || 0;
  const discountedPrice = hasDiscount
    ? Math.round(originalPrice * (1 - discount / 100))
    : originalPrice;

  return (
    <div className="flex items-center">
      <div className="flex w-full flex-col gap-1 border-b border-gray-22 py-2 pe-4">
        <span className="text-body-sm-emphasis text-neutral-fg">{item.title}</span>
        <div className="flex items-start justify-between">
          <div className="my-2 flex flex-wrap gap-1">
            {item.badges?.map((badge) => (
              <ProductBadge key={badge} value={badge} />
            ))}
          </div>
          <StockBadge stock={stock} status={item.stock_status} />
        </div>
        <div className="flex items-center gap-2">
          {hasDiscount ? (
            <>
              <span className="text-body-xs text-neutral-fg">
                {numberFormat(originalPrice)} تومان
              </span>
              <span className="inline-flex h-5 min-w-8 items-center justify-center rounded-md bg-orange px-1.5 text-body-xs-emphasis text-white">
                {discount}%
              </span>
              <span className="text-body-sm-emphasis text-neutral-fg">
                {numberFormat(discountedPrice)} تومان
              </span>
            </>
          ) : (
            <span className="text-body-sm-emphasis text-neutral-fg">
              {numberFormat(originalPrice)} تومان
            </span>
          )}
          {item.commercial_share ? (
            <span className="inline-flex items-center gap-1 rounded bg-orange-pale px-1.5 py-0.5 text-body-xs-emphasis text-orange">
              <img src={promotionIcon} alt="" aria-hidden />
              کمپین
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DealDetailProductsListItem;
